import React from "react";
import clsx from "clsx";
import { ListItem, ListItemProps } from "@material-ui/core";
import useStyles from "./styles";

export const NavListItem = (props: ListItemProps<"div", {button: true}>) => {
  const classes = useStyles();

  return (
    <ListItem
      {...props}
      classes={{
        ...props.classes,
        root: clsx(props.classes?.root, classes.root),
        button: clsx(props.classes?.button, classes.button),
        selected: clsx(props.classes?.selected, classes.selected),
        gutters: clsx(props.classes?.gutters, classes.gutters),
      }}
    >
      {props.children}
    </ListItem>
  );
};
